import React, { useState } from 'react';
import { OutsideClickHandler, ResponsiveImage } from '../../../../components';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import css from './MyActivityModal.module.css';
import { fetchSpecificPost } from '../../CircleCommunityPage.duck';
import { useDispatch } from 'react-redux';
import { createResourceLocatorString } from '../../../../util/routes';
import { FormattedMessage } from '../../../../util/reactIntl';
import { abbreviateName } from '../../../../util/circleHelper';
import { truncateTextByCharacters } from '../../../../util/data';
import moment from 'moment';
import FeedInlineAttachments from '../FeedInlineAttachments';
const MyActivityCard = props => {
  const {
    activityRecord,
    setIsActivityRequested,
    history,
    routeConfiguration,
  } = props;
  const {
    author,
    id,
    name,
    body_plain_text,
    body_text,
    space,
    attachment_count,
    created_at,
    tiptap_body,
    space_id,
    post_id,
    slug,
    show_url
  } = activityRecord || {};
  const displayDate = moment(created_at || "").format("MMM DD YYYY");
  const body = body_plain_text || body_text;
  const { name: authorName, avatar_url } = author || {};

  const handleItemClick = () => {

    //for comments we do not get space slug so extracting it from show url
    const match = show_url?.match(/\/c\/([^\/]+)/) ?? null;
    const extractedSlug = match ? match[1] : slug;
    setIsActivityRequested(false);

    history.push(
      createResourceLocatorString('PostViewPage',
        routeConfiguration, {
        slug: extractedSlug,
        postId: post_id ?? id,
        spaceId: space?.id ? space?.id : space_id,
      },
        post_id ? { commentId: id } : {}
      )
    );
  }
  return (
    <div className={css.bookmarkModalContainer} onClick={handleItemClick}>
      <div className={css.createPostWrapper} onClick={handleItemClick}>
        <div className={css.imageleft}>
          {avatar_url ?
            <ResponsiveImage imagewithURL={avatar_url} /> :
            <div className={css.nameWrapper}>{abbreviateName(name)}</div>
          }
        </div>
        <div className={css.rightDescription}>
          <div className={css.displayNameDate}>
            <div className={css.authorName}>{authorName}</div>
            <span className={css.dateWrapper}>{displayDate}</span>
          </div>
          {name ? <div className={css.postTitle}>{name}</div> : null}
          <div className={css.postDescription}>{!body ? null : truncateTextByCharacters(body, 200)}</div>
          <div className={css.attachmentCount}>
            {attachment_count > 0 ? attachment_count : null}
          </div>

        </div>
      </div>
      {(Array.isArray(tiptap_body?.inline_attachments) && tiptap_body?.inline_attachments.length) || (Array.isArray(tiptap_body?.attachments) && tiptap_body?.attachments.length) ? <div className={css.feedAtachments}>
        <FeedInlineAttachments
          // firstImage={firstImage}
          inline_attachments={Array.isArray(tiptap_body?.inline_attachments) && tiptap_body?.inline_attachments.length ? [tiptap_body.inline_attachments[0]] : []}
          attachments={Array.isArray(tiptap_body?.attachments) && tiptap_body?.attachments.length ? [tiptap_body.attachments[0]] : []}
          isRequestSpace={false}
        />
      </div>
        : null}
    </div>
  );
};
export default MyActivityCard;